import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'modules';
import ClassList from 'components/excelClass/components/ClassList';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { communityExcelHitCount } from 'libs/api/community';
import { ERoute } from 'enums/route.enum';
import { Button } from 'antd';
import styled from 'styled-components';
import { SecondaryColor } from 'GlobalStyles';
import { device } from 'GlobalStyles';
import checkInBoxIcon from 'assets/icons/checkInBox.svg';
import clockIcon from 'assets/icons/clock.svg';
import bottomBanner from 'assets/images/pages/excelClass/bottomBanner.webp';
import excelClassGuideImg from 'assets/images/pages/excelClass/excelClassGuide.webp';
import ExcelSecond from 'assets/images/pages/excelClass/excelSecond.webp';
import introduceTeacherImg from 'assets/images/pages/excelClass/introduceTeacher.webp';
import provideTemplateImg from 'assets/images/pages/excelClass/provideTemplate.webp';
import topBanner from 'assets/images/pages/excelClass/topBanner.webp';

type TBanner = {
  bg?: string;
};

const ExcelClassList = () => {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [videos, setVideos] = useState();

  const apiCallExcelVideo = () => {
    return WrappingApiClient(apiClient.get(`/community/excel_video/landing`));
  };

  const hitCount = async () => {
    const res = await communityExcelHitCount({ board: 'excel_video_lecture' });
  };

  const getExcelVideo = async () => {
    const { success, data } = await apiCallExcelVideo();

    if (success) setVideos(data);
  };

  useEffect(() => {
    getExcelVideo();
    hitCount();
  }, []);

  return (
    <StyledContainer>
      <TopBanner>
        <div className='topBannerLeft'>
          <h1 className='title'>
            MBB 신입사원을 대상으로
            <br />
            진행한 교육과 동일한 엑셀 강의
          </h1>
          {/* <div className='cost'>300,000원</div> */}
          <div className='discountGuide'>3개월 무제한 수강</div>
          <div className='discountPrice'>
            {/* <div className='percentage'>40% 할인</div> <div className='price'>180,000원</div> */}
            <div className='price'>300,000원</div>
          </div>
          {currentUser?.is_active_for_excel_video ? (
            <Link to={ERoute.ExcelClassPlayer.replace(':id', '0')}>
              <Button className='outline secondary'>시청하기</Button>
            </Link>
          ) : (
            <Link to={'/purchase/excel'}>
              <Button className='outline secondary'>수강하기</Button>
            </Link>
          )}
        </div>
        <div className='imageArea'>
          <img src={topBanner} alt='' />
        </div>
      </TopBanner>
      <Banners bg='#f9f9f9'>
        <img className='img' src={ExcelSecond} alt='' style={{ padding: '0 20px' }} />
      </Banners>
      <Banners bg='#090D4D'>
        <div className='textBanner'>
          <img className='clockIcon' src={clockIcon} alt='' />
          <div>
            사용하지 않는 엑셀 기능 및 정의 배우기는 이제 그만!
            <br />
            엑셀 시간을 줄이는 건 <span className='highlight'>요청받은 업무를 한번에 OK 받는 것</span>
            입니다.
            <br />
            실제 업무상황에 맞춰 <span className='highlight'>핵심 기능과 업무 요령 및 노하우</span>를
            익혀보세요!
          </div>
        </div>
      </Banners>
      <Banners>
        <div className='introduceTeacher'>
          <h1 className='title'>강사소개</h1>
          <img className='introduceTeacherImg' src={introduceTeacherImg} alt='' />
        </div>
      </Banners>
      <Banners bg='#f9f9f9'>
        <img className='img' src={excelClassGuideImg} alt='' style={{ padding: '0 20px' }} />
      </Banners>

      <IntroduceClass>
        <article className='recommandPerson'>
          <div className='title'>
            <img className='checkIcon' src={checkInBoxIcon} alt='' />
            <div>{`이런 분들께\n추천드립니다.`}</div>
          </div>
          <div className='descriptionLists'>
            <div className='list'>
              <img className='checkIcon' src={checkInBoxIcon} alt='' />
              <div>
                <span className='strongText'>컨설팅 인턴</span>을 준비중인분
              </div>
            </div>
            <div className='list'>
              <img className='checkIcon' src={checkInBoxIcon} alt='' />
              <div>
                최근에 <span className='strongText'>컨설팅펌을 합격</span>하신분
              </div>
            </div>
            <div className='list'>
              <img className='checkIcon' src={checkInBoxIcon} alt='' />
              <div>
                레주메에 <span className='strongText'>엑셀 능력 professional</span>로 적어
                <br />
                제출했는데 덜컥 합격하신분
              </div>
            </div>
            <div className='list'>
              <img className='checkIcon' src={checkInBoxIcon} alt='' />
              <div>
                요청받은 엑셀 업무를 <span className='strongText'>한번에 OK</span> 받지 못하고
                <br />
                지속적인 수정으로 <span className='strongText'>퇴근이 늦어</span>지시는분
              </div>
            </div>
          </div>
        </article>

        <ClassList isList data={videos} />

        <article className='provideTemplateGuide'>
          <div className='header'>
            <h1 className='title'>제공 템플릿</h1>
            <div className='subtitle'>pdf 2개와 엑셀 파일 3개가 제공됩니다.</div>
          </div>
          <div className='provideTemplateImg'>
            <img src={provideTemplateImg} alt='' />
          </div>
        </article>
      </IntroduceClass>

      <BottomBanner>
        <div className='bannerLeft'>
          <img className='bottomBannerImg' src={bottomBanner} alt='' />
        </div>
        <div className='bannerRight'>
          <h1 className='title'>
            전 BCG 컨설턴트 3인이 전수하는
            <br />
            전략컨설팅 엑셀 강의
          </h1>
          <div className='divider' />
          {/* <div className='cost'>300,000원</div> */}
          <div className='discountGuide'>3개월 무제한 수강</div>
          <div className='discountPrice'>
            {/* <div className='percentage'>40% 할인</div> <div className='price'>180,000원</div> */}
            <div className='percentage'>300,000원</div>
          </div>
          {currentUser?.is_active_for_excel_video ? (
            <Link to={ERoute.ExcelClassPlayer.replace(':id', '0')}>
              <Button className='outline secondary'>시청하기</Button>
            </Link>
          ) : (
            <Link to={'/purchase/excel'}>
              <Button className='outline secondary'>수강하기</Button>
            </Link>
          )}
        </div>
      </BottomBanner>
    </StyledContainer>
  );
};

export default ExcelClassList;

const StyledContainer = styled.main`
  margin: 0 auto;
  word-break: keep-all;
`;

const TopBanner = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
  padding: 20px 0;

  @media screen and ${device.md} {
    margin-top: 100px;
    padding: 20px 0;
  }

  .title {
    margin-bottom: 16px;
    font-size: 35px;
    font-weight: 900;
    line-height: 44px;

    @media screen and ${device.md} {
      margin-bottom: 8px;
      font-size: 18px;
      line-height: 20px;
    }
  }

  .cost {
    margin-bottom: 16px;
    font-size: 22px;
    color: #d6d6d6;
    text-decoration: line-through;

    @media screen and ${device.md} {
      margin-bottom: 8px;
      font-size: 16px;
    }
  }

  .discountGuide {
    font-size: 17px;
    color: ${SecondaryColor};

    @media screen and ${device.md} {
      font-size: 16px;
    }
  }

  .discountPrice {
    display: flex;
    margin-bottom: 12px;
    font-size: 35px;
    font-weight: 900;

    @media screen and ${device.md} {
      flex-direction: column;
      margin-bottom: 6px;
      font-size: 20px;
    }

    .percentage {
      margin-right: 10px;
      color: ${SecondaryColor};
    }

    .price {
      @media screen and ${device.md} {
        margin-top: -7px;
      }
    }
  }

  .topBannerLeft {
    margin-left: 80px;

    @media screen and ${device.md} {
      margin-left: 20px;
    }
  }

  .imageArea {
    max-width: 580px;

    @media screen and ${device.xl} {
      width: 400px;
    }

    @media screen and ${device.lg} {
      width: 280px;
    }

    @media screen and ${device.md} {
      width: 180px;
    }

    img {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      padding-top: 30px;
      transform: translateX(-80px);

      @media screen and ${device.lg} {
        transform: translate(-20px);
      }

      @media screen and ${device.md} {
        transform: translate(-20px);
      }
    }
  }
`;

const Banners = styled.section<TBanner>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-family: 'SBAggro';
  text-align: center;
  color: #ffffff;
  background-color: ${({ bg }) => bg};

  @media screen and ${device.md} {
    font-size: 11px;
  }

  .img {
    max-width: 1000px;
    width: 100%;
    margin: 100px 0 60px 0;

    @media screen and ${device.md} {
      margin: 50px 0;
    }
  }

  .textBanner {
    padding: 80px 0 100px 0;
  }

  .clockIcon {
    margin-bottom: 30px;

    @media screen and ${device.md} {
      width: 25px;
      margin-bottom: 12px;
    }
  }

  .title {
    margin-bottom: 80px;
    font-size: 40px;

    @media screen and ${device.md} {
      margin-bottom: 25px;
      font-size: 18px;
    }
  }

  .introduceTeacher {
    padding: 80px 0;
  }

  .highlight {
    display: inline;
    box-shadow: inset 0 -27px 0 rgba(114, 206, 117, 0.8);
  }

  .introduceTeacherImg {
    max-width: 923px;
    width: 90%;
  }
`;

const IntroduceClass = styled.section`
  padding: 123px 0 100px 0;

  @media screen and ${device.md} {
    padding: 80px 0;
  }

  .recommandPerson {
    display: flex;
    justify-content: center;

    @media screen and ${device.md} {
      flex-direction: column;
      padding: 0 20px;
    }

    .title {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 90px;
      font-size: 30px;
      font-family: 'SBAggro';
      color: #146f60;
      text-align: end;
      white-space: pre-line;

      @media screen and ${device.md} {
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 24px;
        white-space: nowrap;
      }

      .checkIcon {
        max-width: 50px;
        margin-bottom: 30px;

        @media screen and ${device.md} {
          margin-top: 3px;
          width: 25px;
          margin-right: 10px;
        }
      }
    }

    .descriptionLists {
      .list {
        display: flex;
        align-items: flex-start;
        margin-bottom: 33px;
        font-size: 24px;

        @media screen and ${device.md} {
          font-size: 16px;
        }
      }

      .checkIcon {
        width: 24px;
        margin-top: 8px;
        margin-right: 20px;

        @media screen and ${device.md} {
          width: 20px;
          margin: 2px 12px 0 0;
        }
      }

      .strongText {
        font-weight: 900;
      }
    }
  }

  .lectureList {
    max-width: 988px;
    margin: 140px auto 100px auto;

    .title {
      margin: 0;
      padding-bottom: 40px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      font-size: 40px;
      font-weight: 900;
    }

    .lectures {
      display: flex;
      padding: 40px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .lectureThumbnail {
      width: 45%;
      margin-right: 95px;
    }

    .lectureNumber {
      display: inline-block;
      margin-bottom: 20px;
      padding: 0 11px;
      border-radius: 6px;
      font-size: 24px;
      color: white;
      background-color: #72ce76;
    }

    .lectureTitle {
      margin-bottom: 12px;
      font-size: 30px;
      font-weight: 900;
    }

    .info {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .mentor {
      margin-top: 10px;
      font-size: 24px;
      color: #000000;
    }
  }

  .provideTemplateGuide {
    max-width: 988px;
    margin: 140px auto 0 auto;

    @media screen and ${device.md} {
      margin-top: 70px;
    }

    .header {
      display: flex;
      align-items: center;

      @media screen and ${device.md} {
        flex-direction: column;
      }
    }

    .title {
      margin: 0 33px 0 0;
      font-size: 40px;
      font-weight: 900;

      @media screen and ${device.md} {
        margin: 0;
        font-size: 20px;
      }
    }

    .subtitle {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.5);

      @media screen and ${device.md} {
        font-size: 16px;
      }
    }

    .provideTemplateImg {
      width: 90%;
      margin: 60px auto;

      @media screen and ${device.md} {
        margin: 20px auto;
      }

      img {
        width: 100%;
      }
    }
  }
`;

const BottomBanner = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 66px 0;
  background-color: #72ce75;

  @media screen and ${device.md} {
    padding: 20px;
  }

  .bannerLeft {
    max-width: 460px;
    width: 40%;
    margin-right: 120px;

    @media screen and ${device.md} {
      width: 180px;
      margin-right: 30px;
    }

    .bottomBannerImg {
      width: 100%;
    }
  }

  .bannerRight {
    .title {
      margin-bottom: 37px;
      font-size: 35px;
      font-weight: 900;
      color: #ffffff;

      @media screen and ${device.md} {
        margin-bottom: 20px;
        font-size: 18px;
      }
    }

    .divider {
      width: 37px;
      height: 5px;
      margin-bottom: 27px;
      background-color: #ffffff;

      @media screen and ${device.md} {
        width: 20px;
        height: 3px;
        margin-bottom: 18px;
      }
    }

    .cost {
      margin-bottom: 14px;
      font-size: 30px;
      color: rgba(255, 255, 255, 0.5);
      text-decoration: line-through;

      @media screen and ${device.md} {
        margin-bottom: 7px;
        font-size: 16px;
      }
    }

    .discountGuide {
      font-size: 17px;
      color: #ffffff;

      @media screen and ${device.md} {
        font-size: 16px;
      }
    }

    .discountPrice {
      display: flex;
      margin-bottom: 12px;
      font-size: 46px;
      font-weight: 900;
      color: rgba(255, 255, 255, 0.8);

      @media screen and ${device.md} {
        flex-direction: column;
        font-size: 20px;
      }

      .percentage {
        margin-right: 10px;
        color: #ffffff;
      }

      .price {
        @media screen and ${device.md} {
          margin-top: -7px;
        }
      }
    }
  }
`;
